export default __webpack_public_path__ + "static/media/sac_poudre.47f2effa.jpg";